// Auto generated file, do not manually modify!
// com.hotpads.reputation.client.enums.ReputationLandlordIntentionType

export enum ReputationLandlordIntentionType {
  CALL = 'CALL',
  REPORT_INQUIRY_AS_SPAM = 'REPORT_INQUIRY_AS_SPAM',
  SMS = 'SMS',
}

export const ReputationLandlordIntentionType_values = [
  ReputationLandlordIntentionType.CALL,
  ReputationLandlordIntentionType.REPORT_INQUIRY_AS_SPAM,
  ReputationLandlordIntentionType.SMS,
] as const;
